import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, admin }) {
  const { user, loading, openAuth, isAdmin } = useAuth();
  if (loading) return <div className="ca-container py-24 text-slate-500">Loading…</div>;
  if (!user) {
    openAuth("login");
    return <Navigate to="/" replace />;
  }
  if (admin && !isAdmin) return <Navigate to="/dashboard" replace />;
  return children;
}
